import React, { useContext } from "react";
import { DataLegalAndRegTextContext } from "../types";
import { InputElement } from "../../../HtmlComponents/InputElement";
import { useTranslation } from "react-i18next";
import { InputFile } from "../../../HtmlComponents/InputFile";

const InputsLegalAndRegText: React.FC = () => {
  const {
    title, setTitle,
    setImage,
  } = useContext(DataLegalAndRegTextContext);
  const { t } = useTranslation()

  return (
    <div>
      <InputElement
        type="text"
        name={t("Titre")}
        id="Titre"
        value={title}
        setValue={setTitle}
      />
      <InputFile name="Document" setValue={setImage}/>
    </div>
  );
};

export default InputsLegalAndRegText;
